export default __webpack_public_path__ + "static/att_full-88d921d01ac364c38785bbe4d521af18.jpg";